__webpack_require__.p = "/PRODUTOS-LIST/";